import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import {
  selectIsFetchingMachine,
  selectMachine,
} from '../../../../slices/machines';
import { useAppDispatch } from '../../../../store';
import {
  fetchSolutionGrid,
  resetSolutionGrids,
} from '../../../../slices/solutionGrids';
import {
  fetchTemplateCauses,
  fetchTemplateIssues,
} from '../../../../slices/templates';
import { SectionTitle } from '../info/styles';
import { Container } from './styles';
import { Flex } from 'antd';
import SolutionGrid, {
  SolutionGridMode,
} from '../../../../components/solutionGrid';
import { useParams } from 'react-router';

const MachineSolutionGrid = () => {
  const { id } = useParams();
  const dispatch = useAppDispatch();
  const machine = useSelector(selectMachine);
  const isFetchingMachine = useSelector(selectIsFetchingMachine);
  const templateId = machine?.templateID ? String(machine.templateID) : '';

  useEffect(() => {
    if (String(machine?.machineID) !== id) {
      dispatch(resetSolutionGrids());
    }
  }, [machine?.machineID, id, dispatch]);

  useEffect(() => {
    if (!templateId) {
      return;
    }
    dispatch(fetchSolutionGrid({ templateID: templateId }));
    dispatch(fetchTemplateIssues({ templateId }));
    dispatch(fetchTemplateCauses({ templateId }));
  }, [templateId, dispatch]);

  return (
    <Container>
      <SectionTitle>Solution Grid</SectionTitle>
      {!isFetchingMachine && templateId && (
        <Flex flex={1}>
          <SolutionGrid
            templateId={templateId}
            mode={SolutionGridMode.READONLY}
          />
        </Flex>
      )}
    </Container>
  );
};

export default MachineSolutionGrid;
